import { Breadcrumb, Card, Col, Label, ModalPopup, OutlineButton, PrimaryButton, ReactSelectBox, Row, SofturaTable } from "client/CommonComponents"
import './BarcodeReport.scss';
import data from './data.json';
import AssetImage from "./AssetImage";
import excel from '../../../../assets/images/Excel.svg';

const BarcodeReport = ({
  breadcrumlist,
  barcodeColumns,
  showAssetImagePopup,
  setShowAssetImagePopup,
  regionDropDownList,
  selectedRegion,
  marketDropDownList,
  selectedMarket,
  costCenterDropdownList,
  selectedCostCenter,
  handleChange,
  fetchAction,
  serverTotal,
  pagesCount,
  barcodeReportGridData,
  setFilters,
  handleSearchGrid,
  handleFilterClear,
  showGrid,
  onClickExport,
  alreadyHasGridFilterValues
}: any) => {
  return (
    <div>
      <div className='breadcrumb'>
        <div className='order-1'><Breadcrumb items={breadcrumlist} maxDisplayedItems='5'  data-attribute="BarcodeReport_Default_Breadcrumb" /></div>
      </div>
      <div className="barcode-report-container">
        <div className="mb-3">
          <Card data-attribute="BarcodeReport_Default_Card">
            <p className='headingText mb-2'>{'Barcode Replacement Report'}</p>
            {/* <Row>
              <Col xs={12} sm={6} md={3} lg={2} xl={2} className='mb-md-0 mb-3'>
                <Label data-attribute="BarcodeReport_Default_Label">Search By</Label>
                <ReactSelectBox
                  options={[{ label: 'Option 1', value: 'Option 1' }]}
                 data-attribute="BarcodeReport_Default_SearchSelectBox" />
              </Col>
              <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-md-0 mb-3 align-items-end select-region-col'>
                <ReactSelectBox
                  options={[{ label: 'Option 1', value: 'Option 1' }]}
                  placeholder={'Select Region'}
                 data-attribute="BarcodeReport_Default_SearchSelectBox_2" />
              </Col>
              <Col xs={12} sm={12} md={3} lg={2} xl={2} className="search-clear-filter-col align-items-end">
                <OutlineButton text='Search'  data-attribute="BarcodeReport_Default_Button" />
                <PrimaryButton text='Clear Filters'  data-attribute="BarcodeReport_Default_Button_2" />
              </Col>
            </Row> */}
            <Row>
              <Col xs={12} sm={12} md={4} lg={3} xl={3} className='mb-md-0 mb-3'>
                <Label data-attribute="BarcodeReport_Default_Label_2">Region</Label>
                <ReactSelectBox
                  name='region'
                  placeholder='Select Region'
                  options={regionDropDownList}
                  value={selectedRegion ?? ''}
                  isSearchable={true}
                  onChange={(value: any) => handleChange(value, 'region')}  data-attribute="BarcodeReport_region_SearchSelectBox" />
              </Col>
              {selectedRegion && marketDropDownList?.length ?
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className='mb-md-0 mb-3'>
                  <Label data-attribute="BarcodeReport_Default_Label_3">Market</Label>
                  <ReactSelectBox
                    name='market'
                    placeholder='Select Market'
                    options={marketDropDownList}
                    value={selectedMarket ?? ''}
                    isSearchable={true}
                    onChange={(value: any) => handleChange(value, 'market')}  data-attribute="BarcodeReport_market_SearchSelectBox" />
                </Col>
                : null}
              {selectedRegion && selectedMarket && costCenterDropdownList?.length ?
                <Col xs={12} sm={12} md={4} lg={3} xl={3} className='mb-md-0 mb-3 active_costcenter'>
                  <Label data-attribute="BarcodeReport_Default_Label_4">Cost Center</Label>
                  <ReactSelectBox
                    name='costCenter'
                    placeholder='Select Cost Center'
                    options={costCenterDropdownList}
                    onChange={(value: any) => handleChange(value, 'costCenter')}
                    value={selectedCostCenter ?? ''}
                    isSearchable={true}
                    // className='mb-3'
                   data-attribute="BarcodeReport_costCenter_SearchSelectBox" />
                </Col>
                : null}
              <Col xs={12} sm={12} md={3} lg={2} xl={2} className="search-clear-filter-col align-items-end">
                <Col >
                  <OutlineButton onClick={handleSearchGrid} text='Search'  data-attribute="BarcodeReport_Default_Button_3" />
                </Col>
                <Col className="clear-filter me-2 me-lg-2 me-md-2 me-sm-0" >
                  <PrimaryButton onClick={handleFilterClear} text='Clear Filters' disabled={alreadyHasGridFilterValues()}  data-attribute="BarcodeReport_Default_Button_4" />
                </Col>
              </Col>
            </Row>
            <div className=' mb-2 mb-sm-0 excel-container'>
              <div className='pull-right excel-section-barcode-report me-3 mt-4'>
                <img src={excel} alt='excel' onClick={(e?: any) => onClickExport(e)} />
              </div>
            </div>
            {showGrid &&
              <div className="softura-table mt-2">
                <SofturaTable
                  data={barcodeReportGridData ?? []}
                  columns={barcodeColumns}
                  sort={true}
                  defaultPageSize={10}
                  pageSizes={[10, 20, 50]}
                  globalSearch={false}
                  filter={true}
                  fixedHeader={true}
                  defaultPaginationPosition={"Both"}
                  getFilterValue={setFilters}
                  fetchAction={fetchAction}
                  serverTotal={serverTotal}
                  pagesCount={pagesCount}
                  isServerSide={true}
                  loading={false}
                 data-attribute="BarcodeReport_Default_Grid" />
              </div>}
          </Card>
        </div>
      </div>
      {showAssetImagePopup ?
        <ModalPopup
          ShowModalPopupFooter={true}
          ModalPopupTitle={'Asset Image'}
          ModalPopupType="medium-large"
          closeModalPopup={() => setShowAssetImagePopup(false)} data-attribute="BarcodeReport_Default_ModalPopup">
          <div>
            <AssetImage />
          </div>
        </ModalPopup>
        : null}
    </div>
  )
};

export default BarcodeReport